import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../../../lib/connect/clients';
export const volumeLegacyTextKeys = {
    all: [
        'volumeLegacyText'
    ],
    state: (projectId, volumeId)=>[
            ...volumeLegacyTextKeys.all,
            projectId,
            volumeId
        ]
};
/** Which sections of a volume still hold legacy TipTap text (SAD-1202). */ export function useVolumeLegacyText(projectId, volumeId) {
    const query = useQuery({
        queryKey: volumeLegacyTextKeys.state(projectId ?? '', volumeId ?? ''),
        queryFn: async ()=>{
            if (!projectId || !volumeId) return {
                sectionIds: [],
                orphanTextCount: 0
            };
            const r = await projectDataClient.getVolumeLegacyTextState({
                projectId,
                volumeId
            });
            return {
                sectionIds: r.sectionIds ?? [],
                orphanTextCount: r.orphanTextCount ?? 0
            };
        },
        enabled: !!projectId && !!volumeId,
        staleTime: 30000
    });
    const sections = query.data?.sectionIds ?? [];
    const orphanCount = query.data?.orphanTextCount ?? 0;
    return {
        hasUnmovedText: sections.length > 0,
        sections,
        orphanCount,
        isLoading: query.isLoading,
        isError: query.isError
    };
}
